/**
 * The function `closeAnnouncementBar` closes the announcement bar when the close button is clicked and
 * stores a value in sessionStorage.
 */
function closeAnnouncementBar() {
  const btnClose = document.getElementById('close-announcement');

  btnClose.addEventListener('click', () => {
    btnClose.closest('.announcement-bar-section').classList.add('hidden');
    sessionStorage.setItem("announcement-bar", "true");
  })
}

/**
 * The function `hideAnnouncementBar` checks if a session storage item is set to "true" and hides the
 * announcement bar section if it is.
 */
function hideAnnouncementBar() {
  const AnnouncementBarSession = sessionStorage.getItem("announcement-bar");

  if(AnnouncementBarSession && AnnouncementBarSession === "true") {
    const AnnouncementBar = document.querySelector('.announcement-bar-section');
    AnnouncementBar.classList.add('hidden');
  }
}

/**
 * The `initAnnouncementBar` function initializes an announcement bar by hiding and providing a close
 * functionality.
 */
export function initAnnouncementBar() {
  hideAnnouncementBar();
  closeAnnouncementBar();
}